<template>
  <div class="col-12 nopads">
      <base-modal  v-if="selectedItem" size="lg" hide-footer hide-header>
          <edge-pile-editor
              :item="selectedItem"
              :selected-contract="selectedContract"
              @close="selectedItem = null"
              @close-and-update="closeAndUpdate"
          />
      </base-modal>
    <div
      v-if="loading > 0"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '@/components/mixins/TimeUtils'
import {mapHelper} from '@/components/mixins/MapMixin'
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import {condition, roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {restApi} from '../mixins/RestApiMixin'
import {geometryMixin} from "@/components/mixins/GeometryMixin";
import EdgePileEditor from "@/components/velho/EdgePileEditor";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'EdgePileMap',
    components: {BaseModal, EdgePileEditor},
    mixins: [timeUtils, mapHelper, restApi, geometryMixin, stormSewersMixin, roadSignHelper],
    props: {
        map: {
            type: Object,
            default: null
        },
        boundingBox: {
            type: Array,
            default() {
                return []
            }
        },
        filters: {
            type: Array,
            default() {
                return []
            }
        },
        selectedContract: {
            type: Object,
            default: null
        },
        selectedConditions: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data: function () {
        return {
            loading: 0,
            results: [],
            bbox: null,
            visibilityZoomLevel: 13,
            selectedItem: null
        }
    },

    computed: {
        visibleEdgePiles() {
            return this.selectedConditions.length === 0 ? this.results : this.results.filter((value) => this.selectedConditions.includes(value.condition) || (this.selectedConditions.includes(condition.UNSET) && value.condition === undefined))
        }
    },

    watch: {
        map() {
            this.$nextTick(function () {
                this.initView()
            })
        },
        boundingBox() {
            this.updateView()
        },
        filters() {
            this.updateView(true)
        },
        selectedContractIds() {
            this.updateView(true)
        },
        selectedConditions() {
            this.clearDrawnItems()
            this.drawItems()
        }
    },
    beforeUnmount() {
        this.hideAll()
    },
    mounted() {
        this.initView()
    },
    methods: {
        initView: function () {
            if (this.map) {
                this.markerStore = this.map.getMarkerStore()
                this.updateView()
            }
        },

        updateView(force) {
            if (this.map.getMapZoomLevel() < this.visibilityZoomLevel) {
                this.bbox = null
                this.hideAll()
            } else if (force || (this.boundingBox && (!this.bbox || this.isBboxOutsideBbox(this.boundingBox, this.bbox)))) {
                const extendRate = 0.005
                this.bbox = [
                    this.boundingBox[0] - extendRate,
                    this.boundingBox[1] - extendRate,
                    this.boundingBox[2] + extendRate,
                    this.boundingBox[3] + extendRate
                ]
                this.fetchItems()
            }
        },

        closeAndUpdate() {
          this.hideItems()
          this.fetchItems()
        },

        clearDrawnItems: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.EXTERNAL_EDGE_PILES)
            }
        },

        hideItems: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.EXTERNAL_EDGE_PILES)
            }
            this.results = []
        },

        fetchItems: function () {
            this.selectedItem = null
            let params = {}
            if(this.bbox && this.bbox.length > 0) {
                this.loading++
                params.bbox = this.bbox
                this.restFetchParams(this.exteEdgePilesUrl, params, this.handleItems, () => {
                    this.loading--
                })
            } else {
                this.hideItems()
            }
        },

        handleItems: function (response) {
            this.hideItems()
            if (response && response.data) {
                this.results = response.data
                this.drawItems()
            }
            this.loading--
        },

        drawItems: function () {
            this.visibleEdgePiles.forEach(function (result, index) {
                result.geometry.forEach(item => {
                    var points = item.points.map(point => {
                        return {x: point[0], y: point[1]}
                    })
                    this.map.drawPolyLine(index, this.EXTERNAL_EDGE_PILES, points, result.status === 10 ? '#c50505' : '#ec0101', false, false, 3, 1, false, false, result.external_system_id)
                })
            }, this)
        },

        hideAll() {
            this.hideItems()
        },

        editEdgePile(id) {
            this.fetchItem(id)
        },

        fetchItem(id) {
            if (this.loading < 1) {
                this.loading++
                this.restFetch(this.exteEdgePilesUrl + '/' + id, this.handleItem)
            }
        },

        handleItem(response) {
            this.loading--
            if (response && response.data) {
                // Set Velho oid as contract id
                if (this.selectedContractId) {
                    response.data.contract = {
                        id: this.selectedContractId
                    }
                }
                this.selectedItem = response.data
            }
        },
    }
}
</script>
